module.exports = __webpack_public_path__ + "02_veryshort_gold.e026b23e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/02_veryshort_gold.png
// module id = DWI6
// module chunks = 0